<template>
  <div class="page-login">
    <Navigation title="DSHUI商城账号登录" />
    <form>
      <ul class="input-wraper">
        <!-- 输入手机号 -->
        <li class="tel-wrapper mb-20">
          <input class="tel" type="tel" placeholder="输入手机号" maxlength="11" v-model="userName" @keyup="listenKeyUp" />
          <md-icon class="icon-clear" name="close" size="md" @click="userName = ''" v-show="userName.length > 0"></md-icon>
        </li>
        <!-- 输入密码 -->
        <li class="pwd-wrapper mb-20">
          <input class="pwd" type="password" placeholder="输入密码" v-model="passWord" maxlength="16" @keyup="listenKeyUp" />
          <md-icon class="icon-clear" name="close" size="md" @click="passWord = ''" v-show="passWord.length > 0"></md-icon>
        </li>
      </ul>
    </form>
    <div class="btn-login" @click="handleClickLogin">
      <md-activity-indicator
        v-if="loginLoading"
        class="loading-indicator"
        type="carousel"
        :size="10"
        color="#fff"
        text-color="#fff"
      ></md-activity-indicator>
      <span v-show="!loginLoading">登录</span>
    </div>
    <div class="register-wrap">
      <span class="tip">还没有账号?</span>
      <span class="btn-register" @click="handleClickRegister()">立即注册</span>
    </div>
    <!-- 输入邀请码弹窗 -->
    <InputInviteCodePopup ref="inviteCodePopup" @next="handleClickNext"></InputInviteCodePopup>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import InputInviteCodePopup from '@/components/inputInviteCodePopup'
import { Toast, ActivityIndicator, Icon } from 'mand-mobile'
import { checkPhone, getMd5, getInviterUnionID } from '@/utils/help'
import LoginService from '@/services/login'
import LocalStore from '@/utils/localStore'
import Consts from '@/common/consts'
export default {
  name: 'login',
  components: {
    Navigation,
    InputInviteCodePopup,
    [ActivityIndicator.name]: ActivityIndicator,
    [Icon.name]: Icon,
  },
  data() {
    return {
      loginLoading: false,
      userName: '', // 用户名
      passWord: '', // 密码
    }
  },
  methods: {
    listenKeyUp(e) {
      // 监听键盘事件
      if (e && e.keyCode === 13) {
        this.handleClickLogin()
      }
    },
    async handleClickLogin() {
      /** 登录 */
      if (!this.userName) {
        Toast.info('请填写手机号码', 1500)
        return
      }
      if (this.userName.length < 11 || !checkPhone(this.userName)) {
        Toast.info('手机号格式不正确', 1500)
        return
      }
      if (!this.passWord) {
        Toast.info('请填写密码', 1500)
        return
      }
      if (this.passWord.length < 6) {
        Toast.info('密码长度至少6位哦', 1500)
        return
      }
      try {
        this.loginLoading = true
        const res = await this.$http.user.validateUsername({ userName: this.userName })
        const passWord = getMd5(`${this.passWord}${res.data}`) // 对密码进行md5加密
        const d = await LoginService.accountLogin(this.userName, passWord, false)
        this.loginLoading = false
        if (this.$route.query.target) {
          const nextPath = decodeURIComponent(this.$route.query.target)
          this.$router.replace({ path: nextPath })
        } else {
          const routerStack = LocalStore.get(Consts.STORE_ROUTE_STACK)
          if (routerStack && routerStack.length > 1) {
            if (routerStack[1].name !== 'login') {
              this.$router.go(-1)
            } else {
              this.$router.push({ name: 'home' })
            }
          } else {
            this.$router.push({ name: 'home' })
          }
        }
      } catch (err) {
        this.loginLoading = false
      }
    },
    /**
     * 点击注册
     */
    handleClickRegister() {
      let inviterUnionID = getInviterUnionID()
      if (inviterUnionID) {
        this.$router.push({ name: 'register', params: { inviteCode: inviterUnionID } })
      } else {
        this.$refs.inviteCodePopup.inviteCode = ''
        this.$refs.inviteCodePopup.showInviteCodePopup = true
      }
    },
    /**
     * 输入邀请码点击下一步
     */
    handleClickNext(inviteCode) {
      this.$router.push({ name: 'register', params: { inviteCode: inviteCode } })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-login {
  position: relative;
  height: 100%;
  background: #fff;
  .input-wraper {
    margin: 0.6rem 9% 0;
    li {
      width: 100%;
      height: 1rem;
      padding: 0.1rem 0.2rem;
      box-sizing: border-box;
      background-color: #f5f5f5;
      border-radius: 0.44rem;
      margin-top: 0.3rem;
      font-size: 0.32rem;
      &.tel-wrapper,
      &.pwd-wrapper {
        position: relative;
      }
      .tel,
      .pwd {
        width: 100%;
        height: 0.8rem;
        line-height: 0.4rem;
        padding: 0.2rem 0.2rem;
        border: none;
        box-sizing: border-box;
        vertical-align: middle;
        font-size: 0.3rem;
        background-color: #f5f5f5;
        border-radius: 0.44rem;
        &::-webkit-input-placeholder {
          color: #aab2bd;
          font-size: 0.28rem;
        }
      }
      .icon-clear {
        position: absolute;
        text-align: center;
        z-index: 5;
        top: 0.25rem;
        right: 0.2rem;
        width: 0.5rem;
        height: 0.5rem;
        line-height: 0.5rem;
        color: #ccc;
        &:active {
          opacity: 0.3;
        }
      }
    }
  }
  .btn-login {
    height: 0.8rem;
    line-height: 0.8rem;
    border-radius: 0.4rem;
    background-image: linear-gradient(to left, #ff1a1a, #fd2b6b);
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
    margin: 1rem 9% 0;
    cursor: pointer;
    letter-spacing: 0.04rem;
    &:active {
      opacity: 0.5;
    }
    .loading-indicator {
      display: inline-block;
      margin-bottom: 0;
      .md-activity-indicator-svg {
        height: 0.15rem !important;
      }
    }
  }

  .register-wrap {
    // 立即注册
    margin-top: 0.3rem;
    color: #c5cad5;
    height: 0.4rem;
    line-height: 0.4rem;
    text-align: center;
    font-size: 0.26rem;
    font-weight: 300;
    .tip {
      display: inline-block;
      vertical-align: middle;
    }
    .btn-register {
      display: inline-block;
      vertical-align: middle;
      padding: 0 0.1rem;
      line-height: 0.4rem;
      background: #fff;
      color: #232321;
      &:active {
        opacity: 0.3;
      }
    }
  }
}
</style>
